import React, { useEffect } from 'react'
import { Dropdown, DropdownMenuItemType } from 'office-ui-fabric-react/lib/Dropdown';
import { DefaultButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { resolveLineColor } from '../../../../utilities';
import River from './filterComponents/River';
import Location from './filterComponents/Location';

const multiAlt = (props) => {
  const { plot, plotIndex, favorites, userFavorites, loadYears } = props;

  let changed = false
  const applied = JSON.stringify((({ method, source, river, locations, type, alternatives }) => ({ method, source, river, locations, type, alternatives }))(plot.appliedFilters));
  const last = JSON.stringify((({ method, source, river, locations, type, alternatives }) => ({ method, source, river, locations, type, alternatives }))(plot.lastApplied));
  if(applied !== last){
    changed = true
  }

  let keyLocations = plot.availableFilters && plot.availableFilters.favorites && plot.availableFilters.favorites.map(({source, source_id, river, river_id, location, location_id}) => {
    return {
      key: `${source_id}-${river_id}-${location_id}`,
      source_id,
      river_id,
      location_id,
      text: `${location}`
    }
  });
  let userFav = userFavorites.map(({source, source_id, river, river_id, location, location_id}) => {
    return {
      key: `${source_id}-${river_id}-${location_id}`,
      source_id,
      river_id,
      location_id,
      text: `${location}`
    }
  });

  if(userFav.length === 0){
    userFav = [{
      key: 'disabled',
      text: 'No locations identified',
      disabled: true
    }]
  }

  if(!keyLocations){
    keyLocations = []
  }
  let options = [
    { key: 'myLocs', text: 'My Locations', itemType: DropdownMenuItemType.Header },
    ...userFav,
    { key: 'keyLocs', text: 'Key Locations', itemType: DropdownMenuItemType.Header },
    ...keyLocations
  ];

  let srcSelected = plot.appliedFilters.source;
  let rivSelected = plot.appliedFilters.river;
  let locSelected = plot.appliedFilters.locations.join('');
  let disabled = false;
  if(!plot.appliedFilters.source) disabled = true;
  if(!plot.appliedFilters.river) disabled = true;
  if(!plot.appliedFilters.locations.length) disabled = true;
  if(!plot.appliedFilters.type) disabled = true;
  if(plot.isLoading) disabled = true;

  useEffect(() => {
    if(plot.bulkData){
      if(!plot.bulkData[plot.appliedFilters.pickYear]){
        if(plot.appliedFilters.pickYear >= 1931 && plot.appliedFilters.pickYear <= 2012){
          const myTimeout = setTimeout(() => {
            loadYears({...plot.appliedFilters}, plotIndex)
          }, 400)
          return () => clearTimeout(myTimeout);
        }
      } else {
        props.setPlotData(props.buildStatYear(plot.bulkData, plot.appliedFilters.selectedStat, plot.appliedFilters.pickYear, plot.appliedFilters.selectedAlts), plotIndex);
      }
    }
  }, [plot.appliedFilters.pickYear])

  return (
    <div>
      {
        favorites ? (
          <Dropdown 
            placeHolder='Select a Location'
            disabled={!plot.appliedFilters.method}
            className={ (srcSelected && rivSelected && locSelected) ? '' : 'empty'}
            id='location-dropdown'
            selectedKey={`${plot.appliedFilters.source}-${plot.appliedFilters.river}-${plot.appliedFilters.locations.join('')}`}
            onChange={(e, option) => {
              let { source_id, river_id, location_id } = option;
              props.changeFilter({source: source_id, river: river_id, locations: [location_id]}, plotIndex, 'favorite')
            }}
            options={ options }
          />
        ) : (
          <div>
            <Dropdown
              placeHolder="Select a Source"
              disabled={!plot.appliedFilters.method}
              className={srcSelected ? '' : 'empty'}
              id="type-dropdown-filter"
              selectedKey={plot.appliedFilters.source}
              onChange={(e, option) => props.changeFilter({source: option.key}, plotIndex, 'source')}
              options={ plot.availableFilters && plot.availableFilters.sources && plot.availableFilters.sources.map(({source_id, source}) => ({key: source_id, text: source === 'RIVER' ? 'HEC RAS' : source === 'RESERVOIR' ? 'RESSIM' : 'TEMP' })) }
            />
            <Dropdown
              placeHolder="Select a River"
              disabled={!plot.appliedFilters.source}
              className={rivSelected ? '' : 'empty'}
              id="type-dropdown-filter"
              onRenderOption={(props) => <River {...props} />}
              onDismiss={() => props.setMap(null)}
              selectedKey={plot.appliedFilters.river}
              onChange={(e, option) => props.changeFilter({river: option.key}, plotIndex, 'river')}
              options={ plot.availableFilters.rivers.map(({river_id, river}) => ({key: river_id, text: river})) }
            />
            <Dropdown
              disabled={ !plot.appliedFilters.river }
              placeHolder="Select Location"
              className={locSelected ? '' : 'empty'}
              id="location-dropdown"
              selectedKey={ plot.appliedFilters.locations }
              onRenderOption={(props) => <Location {...props} river={plot.appliedFilters.river} favorites={userFav}/>}
              onChange={(e, option) => props.changeFilter({locations: [option.key]}, plotIndex, 'location')}
              options={ plot.availableFilters.locations.map(({location_id, location, favorite}) => ({key: location_id, location_id, text: location}) )}
            />
          </div>
        )
      }
      <Dropdown
        placeHolder="Select a Type"
        disabled={ !plot.appliedFilters.locations.length }
        id="type-dropdown-filter"
        selectedKey={plot.appliedFilters.type}
        className={plot.appliedFilters.type ? '' : 'empty'}
        onChange={(e, option) => {
          props.changeFilter({type: option.key}, plotIndex, 'type');
          props.editChartY({title: option.text}, plotIndex);
        }}
        options={ plot.availableFilters.types.map(({type_id, type, unit}) => ({key: type_id, text: `${type} - (${unit})`})) }
      />
      <DefaultButton
        disabled={disabled}
        className={`apply-filter${(changed && !disabled) ? ' changed' : ''}`}
        text="Apply"
        primary
        onClick={ () => props.applyFilters({...plot.appliedFilters}, plotIndex) }
      />
      { (changed && !disabled) ? (<div className='changed-warning'>Filters have changed since last applied. Click apply to update data.</div>) : null }
      {
        plot.data && plot.data.length > 0 && (
          <div className='flex-row' style={{marginTop: '4px'}}>
          {
            plot.bulkData && (
              <React.Fragment>
                <div className='flex-1 two-col' style={{marginRight: '4px'}}>
                  {
                    plot.appliedFilters && plot.appliedFilters.selectedAlts && Object.keys(plot.appliedFilters.selectedAlts).map((alt, index) => {
                      const lineColor = resolveLineColor(plot.data, alt);
                      return (
                        <div key={index} style={{marginBottom:'4px', borderBottom: `2px solid ${lineColor}`, borderTop: '1px solid #c9c9c9', borderRight: '1px solid #c9c9c9', height: '26px', boxSizing: 'border-box'}}>
                          <Checkbox 
                            className='alt-checkbox'
                            checked={plot.appliedFilters.selectedAlts[alt]}
                            label={alt}
                            onChange={((e, checked) => {
                              let updatedAlts = {...plot.appliedFilters.selectedAlts, [alt]: checked};
                              props.changeFilter({ selectedAlts: updatedAlts }, plotIndex);
                              props.setPlotData(props.buildStatYear(plot.bulkData, plot.appliedFilters.selectedStat, plot.appliedFilters.pickYear || 2012,  updatedAlts), plotIndex);
                              // props.editTrace({visible: checked}, plotIndex, `${alt}-${plot.appliedFilters.selectedStat}-${index}`);
                            })}
                          />
                        </div>
                      )
                    })
                  }
                </div>
                <div className='flex-1 two-col'>
                  <ChoiceGroup
                    className="select-stat"
                    selectedKey={plot.appliedFilters.selectedStat}
                    options={[
                      {
                        key: "maximum",
                        text: 'Maximum',
                      },
                      {
                        key: 'ninetieth',
                        text: '90th Percentile',
                      },
                      {
                        key: 'average',
                        text: 'Average',
                      },
                      {
                        key: 'fiftieth',
                        text: '50th Percentile',
                      },
                      {
                        key: 'tenth',
                        text: '10th Percentile',
                      },
                      {
                        key: 'minimum',
                        text: 'Minimum',
                      },
                      {
                        key: 'value',
                        text: 'Pick Year',
                      },
                    ]}
                    onChange={(e, option) => {
                      props.changeFilter({selectedStat: option.key}, plotIndex);
                      if(plot.bulkData){
                        props.setPlotData(props.buildStatYear(plot.bulkData, option.key, plot.appliedFilters.pickYear || 2012,  plot.appliedFilters.selectedAlts), plotIndex);
                      };
                    }}
                  />
                  {
                    plot.appliedFilters.selectedStat === 'value' && (
                      <div className='pick-year'>
                        <IconButton 
                          iconProps={{iconName: 'ChevronLeft'}}
                          disabled={ plot.isLoading || (plot.appliedFilters.pickYear && (plot.appliedFilters.pickYear < 1932)) }
                          onClick={() => {
                            let date = {...plot.appliedFilters}.pickYear || 2012;
                            date = parseInt(date, 10);
                            date = date - 1;
                            props.changeFilter({pickYear: date}, plotIndex);
                          }}
                        />
                        <TextField
                          value={plot.appliedFilters.pickYear}
                          type='number'
                          min={1931}
                          max={2012}
                          step={1}
                          onChange={(e, value) => {
                            let date = parseInt(value, 10);
                            props.changeFilter({pickYear: date}, plotIndex, 'date');
                          }}
                        />
                        <IconButton 
                          iconProps={{iconName: 'ChevronRight'}}
                          disabled={ plot.isLoading || (!plot.appliedFilters.pickYear) || (plot.appliedFilters.pickYear && (plot.appliedFilters.pickYear > 2011)) }
                          onClick={() => {
                            let date = {...plot.appliedFilters}.pickYear || 2012;
                            date = parseInt(date, 10);
                            date = date + 1;
                            props.changeFilter({pickYear: date}, plotIndex);
                          }}
                        />
                      </div>
                    )
                  }
                </div>
              </React.Fragment>
            )
          }
          </div>
        )
      }
    </div>
  )
}

export default multiAlt



// WEBPACK FOOTER //
// ./src/components/panel/items/filters/multiAlt.js